import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, Observable, of, shareReplay } from 'rxjs';
import { TrajectoryXyzModel } from '../models/trajectory-xyz.model';
import { TotalDepthResult, TrajectoryModel } from '../models/trajectory.model';

const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api`;

@Injectable({
  providedIn: 'root'
})
export class TrajectoryService {
  private trajectoryPointsCache$: Observable<TrajectoryModel[]> = null;
  private tvdsFromMdsCache$: Record<string, Observable<number[]>> = {};
  private trajectoryXyzCache$: Observable<TrajectoryXyzModel> = null;

  constructor(private http: HttpClient) { }

  public getTrajectoryPoints(): Observable<TrajectoryModel[]> {
    if (!this.trajectoryPointsCache$) {
      this.trajectoryPointsCache$ = this.http
        .get<TrajectoryModel[]>(`${PeriforApiEndpoint}/trajectory/points`)
        .pipe(
          catchError(() => of([])),
          shareReplay(1)
        );
    }
    setTimeout(() => this.trajectoryPointsCache$ = null, 1000);
    return this.trajectoryPointsCache$;
  }

  public getTrajectoryXyz(): Observable<TrajectoryXyzModel> {
    if (!this.trajectoryXyzCache$) {
      this.trajectoryXyzCache$ = this.http
        .get<TrajectoryXyzModel>(`${PeriforApiEndpoint}/trajectory/points-xyz`)
        .pipe(
          catchError(() => of(null as TrajectoryXyzModel)),
          shareReplay(1)
        );
    }
    setTimeout(() => this.trajectoryXyzCache$ = null, 1000);
    return this.trajectoryXyzCache$;
  }

  public getTvdsFromMds(mds: number[]): Observable<number[]> {
    const cacheKey = JSON.stringify({ mds });

    if (!this.tvdsFromMdsCache$[cacheKey]) {
      this.tvdsFromMdsCache$[cacheKey] = this.http
        .post<number[]>(`${PeriforApiEndpoint}/trajectory/mds-to-tvds`, {
          measuredDepths: mds
        })
        .pipe(
          catchError(() => of([])),
          shareReplay(1)
        );
    }
    setTimeout(() => this.tvdsFromMdsCache$[cacheKey] = null, 1000);
    return this.tvdsFromMdsCache$[cacheKey];
  }
  
  updateTrajectory(trajectory: TrajectoryModel[]): Observable<TrajectoryModel[]> {
    this.trajectoryPointsCache$ = null;
    return this.http.put<TrajectoryModel[]>(`${PeriforApiEndpoint}/trajectory`, trajectory);
  }

  getTotalDepth(): Observable<TotalDepthResult> {
    return this.http.get<TotalDepthResult>(`${PeriforApiEndpoint}/trajectory/total-depth`);
  }
}
